import {LegacyRegulationWrapper} from "../legacy-regulation-wrapper";
import {OntarioRegulationComponents} from "./components/ontario.regulation-components";
import {IRegulationComponents} from "../regulation-components.interface";
import {
    OntarioExternalLinksHandlersFactory
} from "../../external-links/handlers-factory/regulations/ontario/ontario.external-links-handlers-factory";
import {
    IExternalLinksHandlersFactory
} from "../../external-links/handlers-factory/external-links-handlers-factory.interface";

export class OntarioRegulation extends LegacyRegulationWrapper {
    get components(): IRegulationComponents {
        return new OntarioRegulationComponents(this.services);
    }

    get externalLinks(): IExternalLinksHandlersFactory {
        return new OntarioExternalLinksHandlersFactory(this.services);
    }
}